var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-row",
        { attrs: { "align-v": "end" } },
        [
          _c(
            "b-col",
            { attrs: { cols: "6" } },
            [
              _c("label", [_vm._v(_vm._s(_vm.title))]),
              _vm._v(" "),
              _c("v-select", {
                ref: "produto",
                attrs: { options: _vm.showListaProdutos },
                on: {
                  change: function($event) {
                    return _vm.selectedProduto(_vm.produto)
                  }
                },
                model: {
                  value: _vm.produto,
                  callback: function($$v) {
                    _vm.produto = $$v
                  },
                  expression: "produto"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            { attrs: { cols: "2" } },
            [
              _c("label", { attrs: { for: "" } }, [_vm._v("Qtd.")]),
              _vm._v(" "),
              _c("b-form-input", {
                attrs: { type: "number" },
                on: {
                  keyup: function($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    return _vm.addProduto.apply(null, arguments)
                  }
                },
                model: {
                  value: _vm.quantidade,
                  callback: function($$v) {
                    _vm.quantidade = $$v
                  },
                  expression: "quantidade"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            { attrs: { cols: "2" } },
            [
              _c(
                "label",
                {
                  directives: [
                    {
                      name: "b-tooltip",
                      rawName: "v-b-tooltip.hover",
                      modifiers: { hover: true }
                    }
                  ],
                  attrs: {
                    for: "",
                    title:
                      "Só é permitido informar um valor igual ou maior que o valor de tabela."
                  }
                },
                [_vm._v("Valor Unit.")]
              ),
              _vm._v(" "),
              _c("b-form-input", {
                attrs: { type: "number", step: "0.01" },
                on: {
                  keyup: function($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    return _vm.addProduto.apply(null, arguments)
                  }
                },
                model: {
                  value: _vm.valorUnitario,
                  callback: function($$v) {
                    _vm.valorUnitario = $$v
                  },
                  expression: "valorUnitario"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _vm.brinde
            ? _c(
                "b-col",
                { attrs: { cols: "1" } },
                [
                  _c(
                    "b-form-checkbox",
                    {
                      attrs: { title: "Brinde" },
                      model: {
                        value: _vm.isBrinde,
                        callback: function($$v) {
                          _vm.isBrinde = $$v
                        },
                        expression: "isBrinde"
                      }
                    },
                    [_vm._v("\n                Brinde\n            ")]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "b-col",
            { attrs: { cols: "1" } },
            [
              _c(
                "b-button",
                {
                  staticClass: "mt-4",
                  attrs: { variant: "success" },
                  on: { click: _vm.addProduto }
                },
                [_vm._v("\n                Adicionar\n            ")]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.showProdutoSelecionado
        ? _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col text-primary" }, [
              _vm._v(
                "\n            " +
                  _vm._s(_vm.produto.value.codigo) +
                  " - " +
                  _vm._s(_vm.produto.value.descricao) +
                  " ( R$\n            " +
                  _vm._s(parseFloat(_vm.valorUnitarioAtual).toFixed(2)) +
                  " X " +
                  _vm._s(_vm.quantidade) +
                  " = " +
                  _vm._s(
                    parseFloat(_vm.valorUnitarioAtual * _vm.quantidade).toFixed(
                      2
                    )
                  ) +
                  ") -\n            "
              ),
              _c("small", { staticClass: "text-danger" }, [
                _c("b", [_vm._v(" Saldo = " + _vm._s(_vm.getSaldo) + " ")])
              ]),
              _vm._v(" "),
              _vm.valorUnitarioAtual > parseFloat(_vm.produto.value.preco_venda)
                ? _c("small", { staticClass: "text-success d-block" }, [
                    _c("b", [_vm._v("Acima da tabela")]),
                    _vm._v(
                      " (Tabela: R$ " +
                        _vm._s(
                          parseFloat(_vm.produto.value.preco_venda).toFixed(2)
                        ) +
                        ")\n            "
                    )
                  ])
                : _vm._e()
            ])
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7a3b62fa", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7a3b62fa","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/varejo/produtos/busca-produto.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-7a3b62fa","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/varejo/produtos/busca-produto.vue
// module chunks = 2